import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { TokenAmount } from '@/shared/utils';
import { getTradingStrategyLimits } from '../graphql/cache/strategies';

export const useStrategyLimits = () =>
  useGqlQuery(getTradingStrategyLimits, {
    context: { clientName: 'statechainCache' },
    refetchInterval: 60_000,
    select: (data) =>
      data.limits?.nodes.reduce(
        (acc, limit) => {
          acc[limit.asset] = {
            minimumDeploymentAmount: TokenAmount.fromAsset(
              limit.minimumDeploymentAmount,
              limit.asset,
            ),
            minimumAddedFundsAmount: TokenAmount.fromAsset(
              limit.minimumAddedFundsAmount,
              limit.asset,
            ),
          };
          return acc;
        },
        {} as Record<
          ChainflipAsset,
          { minimumDeploymentAmount: TokenAmount; minimumAddedFundsAmount: TokenAmount } | undefined
        >,
      ),
  });
